<template>
  <div class="cartItem fvlu" @click.stop="clickCard">
    <div class="imgBox">
      <img :src="data.thumbnail" alt="图片缺失" @click.stop="clickImg" />
    </div>
    <div class="orderIfnBox fhlud">
      <p class="productName ellipsis">{{ data?.productName || '暂无名称' }}</p>
      <p class="labelText">{{ data?.productNames || '暂无' }}</p>
      <p class="dealerName ellipsis">{{ data?.dealerName || '' }}</p>
      <p class="carText themeColor ellipsis">{{ data?.carText || '' }}</p>
      <slot name="Ifn"></slot>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from 'vue'

export default {
  props: {
    data: {
      type: [Object],
      default: () => ({})
    }
  },
  components: {},
  emits: ['clickCard', 'clickImg', 'changeMark'],
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value
    })
    const clickCard = v => {
      emit('clickCard', v)
    }
    const clickImg = v => {
      emit('clickImg', v)
    }

    return {
      ...toRefs(state),
      clickCard,
      clickImg
    }
  }
}
</script>
<style lang="scss" scoped>
.imgBox,
.imgBox img {
  position: relative;
  display: inline-block;
  width: 99px;
  height: 74px;
  vertical-align: top;
}
.cartItem {
  width: 100%;
  font-size: 12px;
  color: #333;
}
.orderIfnBox {
  padding-left: 8px;
  width: calc(100% - 110px);
  height: 100%;
}
.productName {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
}
.carText {
  width: 100%;
  line-height: 16px;
}

.dealerName {
  width: 100%;
  color: #999;
}
.labelText {
  width: 100%;
  color: #666;
}
.ifnRow {
  padding: 12px 0 0;
  width: 100%;
  color: #222;
  line-height: 20px;
  font-size: 14px;
  :deep(.van-cell) {
    padding: 0;
  }
}

.priceNum {
  color: #666666;
}
.priceNum + .priceNum {
  margin-left: 16px;
  color: #666666;
}
.priceWeight {
  font-size: 16px;
  font-weight: 600;
  color: #3088c5;
}
</style>
